<template>
  <div>
    <div class="top-bg">
      <!-- tab切换开始 -->
      <van-tabs
        v-model="activeName"
        title-active-color="#fff"
        color="#fff"
        background="none"
        :border="false"
        @click="tabclick"
        v-if="showTab"
      >
        <van-tab title-style="color: #fff;font-weight: 500" title="全部" name="all">内容 1</van-tab>
        <van-tab title-style="color: #fff;font-weight: 500" title="收入" name="income">内容 2</van-tab>
        <van-tab title-style="color: #fff;font-weight: 500" title="支出" name="expend">内容 3</van-tab>
      </van-tabs>
      <!-- tab切换结束 -->
      <!-- tab内容展示开始 -->
      <div class="tab-content-box">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <!-- <van-cell v-for="item in list" :key="item" :title="单元格" label="描述信息" /> -->
            <!-- <van-cell  v-for="item in list" :key="item" center title="单元格" value="1" label="描述信息" /> -->
            <div class="list-box" v-for="(item,index) in list" :key="index">
              <div class="flex-item item-left">
                <p class="text-p1">{{item.sourceName}}</p>
                <p class="text-p2">{{item.createTime}}</p>
              </div>
              <div class="flex-item item-right">+{{item.point}}</div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
      <!-- tab内容展示结束 -->
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import moment from "moment";
export default {
  props: {
    listAttr: {},
    finishAll: { //被告知数据已加载完毕
        type: Boolean
    }
  },
  data() {
    return {
      activeName: "all", //tab默认显示的数据
      showTab: false, // 控制tab是否显示
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page:1,
      pageSize: 20,
      dataFinish:""
    };
  },
  watch: {
    listAttr(val) {
      this.list = val;
    },
    finishAll(val){
        this.dataFinish = val;
    }
  },
  methods: {
    onLoad() {
        console.log(10);
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        this.loading = false;
        this.$emit("changePage",this.page,this.pageSize,this.finished);
         this.page++;
         this.finished = this.dataFinish === true? true: false;
        // if (this.list.length >= 40) {
        //   this.finished = true;
        // }
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/index.styl';
@import '../../../assets/stylus/common.styl';

.tab-content-box {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin: 10px 10px 0;
  padding: 10px 10px 10px 0;
}

.list-box {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e5e5e5;
}

.item-left {
  padding-left: 10px;
}

.flex-item {
  flex: 1;
  margin: auto;

  .text-p1 {
    font-size: 14px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    line-height: 20px;
  }

  .text-p2 {
    font-size: 13px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(202, 202, 210, 1);
    line-height: 18px;
  }
}

.item-right {
  text-align: right;
  font-size: 15px;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: rgba(247, 183, 49, 1);
  line-height: 18px;
}
</style>